<template>
  <div class="cpc">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
    </breadcrumbs>
    <div class="table">
      <div class="table-head">
        <div class="table-head-search">
          <ButtonGroups :pagination="pagination" :tableData="tableData" @pageChange="onPageChange" />
          <div class="filters">
            <div class="filter-item">
              <!-- <span class="mid-filter-title">{{ $t('seller.cpcIndex.filterTitleLabel') }}</span> -->
              <a-input-search style="width: 180px"  v-model:value="query.title" :placeholder="$t('seller.cpcIndex.placeholderTitle')" allow-clear @search="onSearch"
              @enter="onSearch">
              </a-input-search>
              <!-- <a-input v-model:value="query.title" :placeholder="$t('seller.cpcIndex.placeholderTitle')" allow-clear style="width: 220px" /> -->
            </div>
            <div class="statusFilter">
              <a-input-search v-model:value="query.asin" :placeholder="$t('seller.cpcIndex.placeholderAsin')" style="width: 180px"  allow-clear @search="onSearch"
              @enter="onSearch">
              </a-input-search>
              <!-- <span class="mid-filter-title">{{ $t('seller.cpcIndex.filterAsinLabel') }}</span>
              <a-input v-model:value="query.asin" :placeholder="$t('seller.cpcIndex.placeholderAsin')" allow-clear style="width: 180px" /> -->
            </div>
            <div class="statusFilter publisher-filter">
              <span class="mid-filter-title">{{ $t('seller.cpcIndex.filterPublisherLabel') }}</span>
              <div class="publisher-select-wrap">
                <PublisherSelect v-model="query.publisherId" :sync-session-publisher-name="false" />
              </div>
            </div>
            <div class="filters-create-action">
              <a-button type="primary" @click="goCreateCampaign">{{ $t('seller.cpcIndex.createCampaign') }}</a-button>
            </div>
          </div>

        </div>
        <div class="filters-box" ref="filterContentRef">
          <div class="filters-box-content">
            <div class="filter-item">
              <div class="label">{{ $t('seller.cpcIndex.status') }}</div>
              <div class="checkbox">
                <a-checkbox v-model:checked="query.changeStatus">{{ $t('seller.common.active') }}</a-checkbox>
                <a-checkbox v-model:checked="query.changeFinished">{{ $t('seller.cpcIndex.finished') }}</a-checkbox>
                <a-checkbox v-model:checked="query.changeIncoming">{{ $t('seller.cpcIndex.incoming') }}</a-checkbox>
              </div>
            </div>
            <div class="filter-item">
              <div class="label">{{ $t('seller.cpcIndex.linkType') }}</div>
              <div class="checkbox">
                <a-checkbox v-model:checked="query.changeAttribution">Attribution</a-checkbox>
                <a-checkbox v-model:checked="query.changeAssociate">Associate</a-checkbox>
              </div>
            </div>
            <div class="filter-item">
              <div class="label">{{ $t('seller.cpcIndex.startsOnOrAfter') }}</div>
              <a-date-picker style="width: 180px" :value="query.startAt || null" @change="onStartDateChange" />
            </div>
            <div class="filter-item">
              <div class="label">{{ $t('seller.cpcIndex.endsOnOrBefore') }}</div>
              <a-date-picker style="width: 180px" :value="query.endAt || null" :disabled-date="disabledEndDate"
                @change="onEndDateChange" />
            </div>
            <div class="filterBar-content">

              <div class="action-buttons">
                <div class="reset-filters" @click="resetFilters">
                  {{ $t('seller.cpcIndex.reset') }} {{ activeFilterCount }}
                  {{ activeFilterCount === 1 ? $t('seller.cpcIndex.filterSingular') : $t('seller.cpcIndex.filterPlural') }}
                </div>

                <a-button type="primary" shape="round" @click="onSearch">{{ $t('seller.common.confirm') }}</a-button>
              </div>
            </div>
          </div>

        </div>

      </div>

      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="tableData"
        :change="onTableChange" :loading="load" :scroll="{ x: 1650 }">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'title'">
            <a-tooltip placement="topLeft" :title="titleOverflowTip(record, index) ? record.title : ''">
              <span class="title-cell text-style" @mouseenter="onTitleCellEnter($event, record, index)">{{ record.title
              }}</span>
            </a-tooltip>
          </template>
          <template v-else-if="column.key === 'asin'">
            <div v-if="asinStackView(record).kind === 'images'" class="asin-stack">
              <div class="asin-stack-avatars" aria-hidden="true">
                <div v-for="(url, i) in asinStackView(record).visibleUrls" :key="`img-${record.id}-${i}-${url}`"
                  class="asin-stack-item" :style="{ zIndex: i + 1 }">
                  <img :src="url" alt="" />
                </div>
                <div v-if="asinStackView(record).more > 0" class="asin-stack-item asin-stack-more"
                  :style="{ zIndex: asinStackView(record).visibleUrls.length + 1 }">
                  +{{ asinStackView(record).more }}
                </div>
              </div>
            </div>
            <div v-else-if="asinStackView(record).kind === 'countOnly'" class="asin-stack-count-only">
              <span>{{ $t('seller.cpcIndex.asinCount', { n: asinStackView(record).total }) }}</span>
            </div>
            <span v-else-if="record.asin" class="asin-stack-fallback">{{ record.asin }}</span>
            <span v-else class="asin-stack-empty">—</span>
          </template>
          <template v-if="column.key === 'cpc'">
            <div class="info-item">
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../assets/images/img/AT@2x.png" :alt="$t('seller.cpcIndex.imgAltAttribution')" class="icon" />
                  <span class="item-text">attribution</span>
                </div>
                <div class="info-item-row-value">
                  {{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.attributionCpcUnitPrice }}
                </div>
              </div>
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../assets/images/img/AS@2x.png" :alt="$t('seller.cpcIndex.imgAltAssociate')" class="icon" />
                  <span class="item-text">associate</span>

                </div>
                <div class="info-item-row-value">
                  {{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.associateCpcUnitPrice }}
                </div>
              </div>

            </div>
          </template>
          <template v-if="column.key === 'budget'">
            <div>
              <p><span class="title-text">{{ $t('seller.cpcIndex.budgetTotal') }}</span> <span class="value-text green">{{
                CURRENCY_DATA_MAPPER[record.currency] }}{{ record.totalBudget }}</span></p>
              <p><span class="title-text">{{ $t('seller.cpcIndex.budgetRemain') }}</span> <span class="value-text red">{{
                CURRENCY_DATA_MAPPER[record.currency] }}{{ record.budgetRemaining }}</span></p>
            </div>
          </template>
          <template v-if="column.key === 'startDate'">
            <div class="text-style">
              {{ moment(record.startDateTimestamp).tz(timeZone).format('YYYY-MM-DD') }}
            </div>

          </template>
          <template v-if="column.key === 'endDate'">
            <div class="text-style">
              {{ moment(record.endDateTimestamp).tz(timeZone).format('YYYY-MM-DD') }}
            </div>
          </template>
          <template v-if="column.key === 'linkType'">
            <div class="link-type-cell" v-if="record.attributionCpcEnabled">
              <div class="item">
                <img src="../../../assets/images/img/AT@2x.png" :alt="$t('seller.cpcIndex.imgAltAttribution')" class="icon" />
                <span class="item-text">Attribution</span>
              </div>
            </div>
            <div class="link-type-cell" v-if="record.associateCpcEnabled" style="margin-top: 10px;">
              <div class="item">
                <img src="../../../assets/images/img/AS@2x.png" :alt="$t('seller.cpcIndex.imgAltAssociate')" class="icon" />
                <span class="item-text">Associate</span>

              </div>
            </div>
          </template>
          <template v-if="column.key === 'cap'">
            <div>
              <p>
                <span class="title-text">{{ $t('seller.cpcIndex.capTotal') }}{{ record.publisherTotalCapUpTo ? $t('seller.cpcIndex.capUpTo') : '' }}</span>

                <span class="value-text green"> {{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.publisherTotalCap
                }}</span>

              </p>
              <p>
                <span class="title-text">{{ $t('seller.cpcIndex.capDaily') }}{{ record.publisherDailyCapUpTo ? $t('seller.cpcIndex.capUpTo') : '' }}</span>
                <span class="value-text red"> {{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.publisherDailyCap
                }}</span>

              </p>
            </div>
          </template>
          <template v-if="column.key === 'status'">
            <Status :type="statusType(record.status)" :text="record.status" :noBorder="true" />
          </template>
          <template v-if="column.key === 'publishers'">
            <div class="text-style">
              {{ record.joinedPublisherCount }}/{{ record.invitedPublisherCount }}
            </div>

          </template>
          <template v-if="column.key === 'action'">
            <div class="action-cell">
              <artmisads-select-button size="small" @click="editCampaign(record)"
                v-if="record.status !== 'FINISHED'">{{ $t('seller.cpcIndex.edit') }}</artmisads-select-button>
              <artmisads-select-button size="small" @click="viewCampaign(record)">{{ $t('seller.cpcIndex.view') }}</artmisads-select-button>
            </div>
          </template>
        </template>
      </artmisads-table>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, reactive, ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import debounce from "lodash/debounce"
import { useRouter } from "vue-router"
import breadcrumbs from "~/pages/seller/breadcrumbs.vue"
import ButtonGroups from "../Brands/components/buttonGroups.vue"
import Status from "~/components/Status.vue"
import { sellerCpcApi } from "~/server"
import { CURRENCY_MAPPER, COUNTRY_TIME_TZ, CURRENCY_DATA_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"
import moment from "moment"
import PublisherSelect from "@/components/PublisherSelect.vue"
import { SearchOutlined } from '@ant-design/icons-vue'
const { t } = useI18n()
const store = useUserInfoStore()
const userInfo = store.userInfo
const timeZone = COUNTRY_TIME_TZ[userInfo.countryCode] || 'US'
const breadcrumbsData = computed(() => ({
  title: t("seller.cpcIndex.breadcrumbTitle"),
  color: "#26AADC",
  des: t("seller.cpcIndex.breadcrumbDes"),
  hasTitleIcon: false,
  links: [
    {
      name: t("seller.common.home"),
      path: "/seller/dashboard",
    },
    {
      name: t("seller.cpcIndex.breadcrumbCpc"),
      path: "/seller/cpc",
    },
  ],
}))

const load = ref(false)
const router = useRouter()
const statusFilterRef = ref(null)
const linkTypeFilterRef = ref(null)
const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || 'US'
const query = reactive({
  title: "",
  asin: "",
  statuses: "",
  publisherId: "",
  linkType: "",
  startAt: null,
  endAt: null,
  changeStatus: false,
  changeFinished: false,
  changeAttribution: false,
  changeAssociate: false,
  changeIncoming: false,
})

const hasPublisherId = (v) => v !== "" && v != null

const activeFilterCount = computed(() => {
  let n = 0
  if (String(query.title || "").trim()) n += 1
  if (String(query.asin || "").trim()) n += 1
  if (hasPublisherId(query.publisherId)) n += 1
  if (query.changeStatus) n += 1
  if (query.changeFinished) n += 1
  if (query.changeIncoming) n += 1
  if (query.changeAttribution) n += 1
  if (query.changeAssociate) n += 1
  if (query.startAt) n += 1
  if (query.endAt) n += 1
  return n
})

const tableData = ref([

])

const titleOverflow = reactive({})

const titleRowKey = (record, index) => record.id ?? index

const titleOverflowTip = (record, index) =>
  !!record.title && !!titleOverflow[titleRowKey(record, index)]

const onTitleCellEnter = (e, record, index) => {
  const el = e?.currentTarget
  if (!el) return
  titleOverflow[titleRowKey(record, index)] =
    el.scrollWidth > el.clientWidth
}

const ASIN_STACK_VISIBLE = 3

/** 列表行里的商品摘要，接口一般为 record.products: [{ productId, asin, imageUrl, ... }] */
const asinStackProductList = (record) => {
  const raw =
    record?.products ??
    record?.asinProducts ??
    record?.productList ??
    record?.productThumbnails ??
    []
  return Array.isArray(raw) ? raw : []
}

const isUsableProductImageUrl = (raw) => {
  const u = String(raw ?? "").trim()
  if (!u || u === "string") return false
  return /^https?:\/\//i.test(u) || u.startsWith("//") || u.startsWith("data:")
}

const asinStackImageUrls = (record) => {
  const arr = asinStackProductList(record)
  const urls = []
  const seen = new Set()
  for (const p of arr) {
    const u = String(p?.imageUrl || p?.productImage || p?.image || "").trim()
    if (!u || seen.has(u)) continue
    seen.add(u)
    if (isUsableProductImageUrl(u)) urls.push(u)
  }
  return urls
}

const asinStackTotalCount = (record) => {
  const products = asinStackProductList(record)
  const fromList = products.length
  const urls = asinStackImageUrls(record)
  const n = Number(
    record?.productCount ??
    record?.productsCount ??
    record?.totalProducts ??
    record?.asinCount ??
    0,
  )
  if (fromList > 0) {
    if (Number.isFinite(n) && n > 0) return Math.max(n, fromList)
    return fromList
  }
  if (Number.isFinite(n) && n > 0) return Math.max(n, urls.length)
  return urls.length
}

/** 列表单元展示：有图叠放；仅有数量时显示文案 */
const asinStackView = (record) => {
  const urls = asinStackImageUrls(record)
  const total = asinStackTotalCount(record)
  if (total <= 0) return { kind: "none" }
  const visibleUrls = urls.slice(0, ASIN_STACK_VISIBLE)
  const more = Math.max(0, total - ASIN_STACK_VISIBLE)
  if (!visibleUrls.length) {
    return { kind: "countOnly", total, more }
  }
  return { kind: "images", visibleUrls, more, total }
}

const asinStackTooltip = (record) => {
  const products = asinStackProductList(record)
  const asins = products
    .map((p) => String(p?.asin || "").trim())
    .filter(Boolean)
  if (asins.length) {
    const head = asins.slice(0, 25).join(", ")
    return asins.length > 25 ? `${head}…` : head
  }
  if (record?.asin) return String(record.asin)
  return ""
}


const columns = computed(() => [
  { title: t("seller.cpcIndex.colTitle"), dataIndex: "title", key: "title", width: 180 },
  { title: t("seller.cpcIndex.colAsin"), dataIndex: "asin", key: "asin", width: 200 },
  { title: t("seller.cpcIndex.colCpc"), dataIndex: "cpc", key: "cpc", width: 200 },
  { title: t("seller.cpcIndex.colBudget"), dataIndex: "budget", key: "budget", width: 170 },
  {
    title: t("seller.cpcIndex.colBudgetCapPublisher"),
    dataIndex: "cap",
    key: "cap",
    width: 220,
  },
  { title: t("seller.cpcIndex.colStartDate"), dataIndex: "startDate", key: "startDate", width: 130 },
  { title: t("seller.cpcIndex.colEndDate"), dataIndex: "endDate", key: "endDate", width: 130 },
  { title: t("seller.cpcIndex.colLinkType"), dataIndex: "linkType", key: "linkType", width: 140 },
  { title: t("seller.cpcIndex.colPublishers"), dataIndex: "publishers", key: "publishers", width: 120 },
  { title: t("seller.cpcIndex.colStatus"), dataIndex: "status", key: "status", width: 130 },
  { title: t("seller.cpcIndex.colAction"), key: "action", width: 150, fixed: "right" },
])

const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ["10", "20", "30", "40", "50"],
})



// const pagedData = computed(() => {
//   const start = (pagination.current - 1) * pagination.pageSize
//   const end = start + pagination.pageSize
//   return filteredData.value.slice(start, end)
// })

const onTableChange = ({ current, pageSize }) => {

  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getCpcCampaignsList()
}

const onPageChange = (current) => {
  pagination.current = current
  getCpcCampaignsList()
}

const isEndAfterStart = (endDate, startDate) => {
  if (!endDate || !startDate) return true
  return moment(endDate).startOf("day").valueOf() > moment(startDate).startOf("day").valueOf()
}

const disabledEndDate = (current) => {
  if (!query.startAt) return false
  return !isEndAfterStart(current, query.startAt)
}

const onStartDateChange = (date) => {
  query.startAt = date || null
  if (query.startAt && query.endAt && !isEndAfterStart(query.endAt, query.startAt)) {
    query.endAt = null
  }
}

const onEndDateChange = (date) => {
  if (date && query.startAt && !isEndAfterStart(date, query.startAt)) {
    query.endAt = null
    return
  }
  query.endAt = date || null
}

const onSearch = () => {
  pagination.current = 1

  getCpcCampaignsList()
}

/** Title / ASIN：输入即搜（防抖）；Publisher：变更立即搜 */
const debouncedSearchFromTitleAsin = debounce(() => {
  pagination.current = 1
  getCpcCampaignsList()
}, 400)

// watch(
//   () => [query.title, query.asin],
//   () => {
//     debouncedSearchFromTitleAsin()
//   },
// )

watch(
  () => query.publisherId,
  () => {
    debouncedSearchFromTitleAsin.cancel()
    pagination.current = 1
    getCpcCampaignsList()
  },
)

onBeforeUnmount(() => {
  debouncedSearchFromTitleAsin.cancel()
})
const getCpcCampaignsList = async () => {
  let param = {
    ...query,
    page: pagination.current,
    size: pagination.pageSize,
    marketplace: CURRENCY_MAPPER[countryCode].host
  }
  const statusesList = []
  if (param.changeStatus) {
    statusesList.push('active')

  }
  if (param.changeFinished) {
    statusesList.push('finished')

  }
  if (param.changeIncoming) {
    statusesList.push('incoming')

  }
  if (statusesList.length > 0) {
    param.statuses = statusesList.join(',')
  }
  if (param.changeStatus && param.changeFinished && param.changeIncoming) {
    param.statuses = ''
  }

  if (param.changeAttribution) {
    param.linkType = 'ATTRIBUTION'
  }
  if (param.changeAssociate) {
    param.linkType = 'ASSOCIATE'
  }
  if (param.changeAttribution && param.changeAssociate) {
    param.linkType = ''
  }
  delete param.changeStatus
  delete param.changeFinished
  delete param.changeAttribution
  delete param.changeAssociate
  if (param.startAt) {
    param.startDateTimestamp = moment(moment(param.startAt).format('YYYY-MM-DD') + ' 00:00:00').valueOf()
  }
  if (param.endAt) {
    param.endDateTimestamp = moment(moment(param.endAt).format('YYYY-MM-DD') + ' 23:59:59').valueOf()
  }
  delete param.startAt
  delete param.endAt
  const { data } = await sellerCpcApi.getCpcCampaigns(param)
  tableData.value = data.data
  pagination.total = data.total
}
const statusType = (status) => {
  if (status === "ACTIVE") return "active"
  if (status === "FINISHED") return "finished"
  return "inactive"
}

const resetFilters = () => {
  Object.assign(query, {
    title: "",
    asin: "",
    status: "",
    publisherId: "",
    linkType: "",
    startAt: null,
    endAt: null,
    changeStatus: false,
    changeFinished: false,
    changeAttribution: false,
    changeAssociate: false,
    changeIncoming: false,
  })

  onSearch()
}

const viewCampaign = (record) => {
  router.push({
    name: "seller cpc detail",
    params: { id: record.id },
  })
}

const editCampaign = (record) => {
  router.push({
    name: "seller cpc create",
    query: {
      mode: "edit",
      campaignId: record.id,
    },
  })
}
getCpcCampaignsList()
const goCreateCampaign = () => {
  router.push({ name: "seller cpc create" })
}
</script>
<style scoped lang="less">
.filters-box {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  padding: 15px 16px;
  margin: 16px 0;
  width: 100%;
  border-radius: 8px;
  background: #F8F7FC;
  justify-content: space-between;

  .filters-box-content {
    display: flex;
    gap: 22px;
    flex-wrap: wrap;

  }

  .filter-item {
    .label {

      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      padding-bottom: 4px;
      opacity: 0.7;
    }
  }

  .checkbox {
    display: flex;
    height: 32px;
    padding: 0 8px;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: #EAE8F0;

  }

  .statusFilter {

    // position: relative;
    z-index: 2;
    // margin-left: 18px;
    // opacity: 0.7;
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-2);
    letter-spacing: 0.4px;
    line-height: 20px;
  }
}

.table-head-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.text-style {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: rgba(15, 6, 41, 1);
}

.title-text {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(15, 6, 41, 1);
}

.value-text {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;
  text-transform: uppercase;

}

.green {
  color: rgba(0, 153, 71, 1);
}

.red {
  color: rgba(235, 78, 61, 1);
}

.cpc {
  padding: 16px;
  padding-top: unset;
}

.item {
  display: flex;
  padding: 3px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #f1f0f5;
  min-width: 111px;

  .icon {
    width: 20px !important;
    height: 20px !important;
  }

  .item-text {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .info-item-row-value {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0px;
    text-transform: uppercase;
    color: rgba(15, 6, 41, 1);
  }

}

.link-type-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 111px;
  flex-direction: column;

}

.table {
  padding: 0 16px 16px;
  background-color: var(--color-white);
  border-radius: 8px;
  box-shadow: var(--section-box-shadow-6);
}

.table-head {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 16px 0;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px !important;
  flex: 1;
  min-width: 0;
  margin-left: 26px;
}

.filters-create-action {
  margin-left: auto;
}

.filterBar {
  padding-bottom: 12px;
}

.filterBar-content {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

.statusFilter {
  display: flex;
  align-items: center;
}

.publisher-filter {
  min-width: 240px;
}

.publisher-select-wrap {
  width: 200px;
}

.mid-filter-title {
  margin-right: 8px;
  color: #5f6572;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.reset-filters {
  font-family: Sora;
  font-weight: 400;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: rgba(108, 61, 242, 1);
  cursor: pointer;
}

.title-cell {
  display: inline-block;
  max-width: 165px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

}

.asin-stack {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
}

.asin-stack-avatars {
  display: inline-flex;
  align-items: center;
  padding-left: 2px;
}

.asin-stack-item {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  // border: 2px solid #fff;
  box-sizing: border-box;
  overflow: hidden;
  margin-left: -10px;
  flex-shrink: 0;
  background: #f3f4f6;
  box-shadow: 0 0 0 1px rgba(15, 6, 41, 0.06);

  &:first-child {
    margin-left: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.asin-stack-more {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0px;

  color: rgba(87, 81, 105, 1);
  background: rgba(241, 240, 245, 1);
  line-height: 1;
}

.asin-stack-empty,
.asin-stack-fallback {
  color: #9ca3af;
  font-size: 13px;
}

.asin-stack-fallback {
  color: #374151;
}

.asin-stack-count-only {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: default;
}

.link-cell {
  color: #7d64ff;
  text-decoration: none;
}

.action-cell {
  display: flex;
  gap: 10px;

  a {
    color: #7d64ff;
    text-decoration: none;
  }
}

@media (max-width: 1200px) {
  .table-head {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>